<script setup>
import { useRouter } from 'vue-router'
import PwaInstall from './components/menu/PwaInstall.vue'
import { useConfigStore, useUserStore } from '~/store/index'

const { $i18n } = useNuxtApp()

await useUserStore().fetchUser()
await useConfigStore().fetchConfig()

if (useConfigStore().maintenance) {
    const router = useRouter()
    router.replace('/')
}

const currentCodeDep = useConfigStore().currentConfig.code_departement
// console.log('i18n', $i18n, $i18n.locales.value, $i18n.locale.value, currentCodeDep)
if (currentCodeDep) {
    $i18n.setLocale(currentCodeDep)
    // console.log('i18n setted', $i18n, $i18n.locale.value)
}
</script>

<template>
    <div>
        <NuxtLayout>
            <MenuNotificationsAlertesAlert v-if="$vuetify.display.mobile" />
            <MenuNotificationsAlertesPopup v-else />
            <NuxtPage />
            <PwaInstall v-if="$vuetify.display.mobile" />
        </NuxtLayout>
    </div>
</template>
